// Reusable 4x6 Target pallet SSCC-18 (Tare) label (GS1-128 + (420) postal); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-411. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomTargetPalletSsccLabelFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  targetDC: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  postalCode: yup.string().nullable().optional(),
  postalBarcode: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  palletSequence: yup.string().nullable().optional(),
  palletCount: yup.string().nullable().optional(),
  palletWeight: yup.string().nullable().optional(),
  weightUom: yup.string().nullable().optional(),
  palletContentsSummary: yup.string().nullable().optional(),
  vendorInfo: yup.string().nullable().optional(),
  palletSscc: yup.string().nullable().optional(),
  palletSsccBarcode: yup.string().nullable().optional(),
})

export type BiomTargetPalletSsccLabelFileData = yup.InferType<
  typeof biomTargetPalletSsccLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomTargetPalletSsccLabelFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomTargetPalletSsccLabelFileMappings: RequiredFileData = {
  customerDisplayName: 'a0d736fe-d130-4b5d-a15c-8caf87199634',
  shipFromAddress: 'ba51ef16-012e-4342-b5f4-b46687987f8d',
  targetDC: '19c17363-6593-4420-9f7d-9c63fa716eff',
  shipToAddress: 'bf522ee9-24b9-4c79-8a7b-5ea8c932bb9b',
  postalCode: 'f3fe571a-0b4f-4ba4-8f46-a7467eef3b07',
  postalBarcode: '78954c73-ca9a-4470-9857-f8abe2632c79',
  carrier: '9dacf1ec-5464-4214-87c6-274d4cd7a90a',
  poNumber: '4734bdae-36c6-45be-900e-5bab7dfd7793',
  palletSequence: '4983cf5b-72f8-484c-8b0c-aeec4b1ba48e',
  palletCount: '2a5b6b1d-83ab-42aa-899b-ef7994856f0f',
  palletWeight: '3b1b82cf-9e0c-46f9-a415-ae13e01699a1',
  weightUom: '8dda3ee2-e718-40eb-8589-3a754e724772',
  palletContentsSummary: 'bf10d63b-cb33-458d-910c-6db064c46adb',
  vendorInfo: '48628261-8bc4-424c-9a45-b6d51f8885ab',
  palletSscc: '41f365ab-d1fc-485d-9112-12a90e8a279c',
  palletSsccBarcode: '7c68c686-1117-4464-8f18-30d2113b796a',
}
